import * as React from "react";
import { ThemeProvider } from "styled-components";
import { StyledEngineProvider } from "@mui/material/styles";
import getTheme from "src/theme";
import { StylesProvider, ThemeProvider as MuiThemeProvider } from "@mui/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter } from "react-router-dom";
import { TemplateViewsProvider } from "src/components/providers/template-views-provider";
import { OrgProvider } from "src/components/providers/org-provider";
import { AuthProvider } from "./auth-context";
import LoadingProvider from "./loading-provider";
import { FlagsProvider } from "./feature-flags";
import { ToastContextProvider } from "./toast-provider";
import NotificationProvider from "./notification";

const AppProviders: React.FC<{ children: (Function) => React.ReactElement }> = ({ children }) => {
    const [appliedTheme, setAppliedTheme] = React.useState(getTheme(true));

    const handleSetDark = (isDark: boolean) => {
        setAppliedTheme(getTheme(isDark));
    };

    return (
        <BrowserRouter>
            <LoadingProvider>
                <ToastContextProvider>
                    <AuthProvider>
                        <FlagsProvider>
                            <NotificationProvider>
                                <StylesProvider injectFirst>
                                    <StyledEngineProvider injectFirst>
                                        <MuiThemeProvider theme={appliedTheme}>
                                            <ThemeProvider theme={appliedTheme}>
                                                <CssBaseline />
                                                <TemplateViewsProvider>
                                                    <OrgProvider>
                                                        {children({ handleSetDark })}
                                                    </OrgProvider>
                                                </TemplateViewsProvider>
                                            </ThemeProvider>
                                        </MuiThemeProvider>
                                    </StyledEngineProvider>
                                </StylesProvider>
                            </NotificationProvider>
                        </FlagsProvider>
                    </AuthProvider>
                </ToastContextProvider>
            </LoadingProvider>
        </BrowserRouter>
    );
};

export default AppProviders;
